var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { ContinuousReportSummaryPartner } from '@/common/types/ContinuousReportSummaryPartner';
import MasterDataConsumer from '@/common/mixins/MasterDataConsumer';
import { PartnerType } from '@/common/types/PartnerType';
import { optionsFor } from '@/common/utils/enumUtilities';
import { Option } from '@/common/types/Option';
import OrganisationSearchAndSelect from '@/common/components/OrganisationSearchAndSelect.vue';
import SingleSelectAccessible from '@/common/components/SingleSelectAccessible.vue';
import MultiselectRowAccessible from '@/common/components/MultiselectRowAccessible.vue';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import CheckBoxDialogRow from '@/common/components/CheckBoxDialogRow.vue';
import { Savable } from '@/common/mixins/Savable';
var PartnerControl = /** @class */ (function (_super) {
    __extends(PartnerControl, _super);
    function PartnerControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.descriptionKey = "";
        _this._selectedOrganisation = null;
        return _this;
    }
    Object.defineProperty(PartnerControl.prototype, "selectedOrganisation", {
        get: function () {
            if (this.partner.type == PartnerType.Organisation) {
                if (this._selectedOrganisation == null && this.partner.name)
                    return { name: this.partner.name, id: null };
                else if (this._selectedOrganisation != null && this._selectedOrganisation.name == this.partner.name)
                    return this._selectedOrganisation;
            }
            return null;
        },
        set: function (value) {
            this._selectedOrganisation = value;
            this.partner.name = value === null || value === void 0 ? void 0 : value.name;
            this.forceSave();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "PartnerType", {
        get: function () {
            return PartnerType;
        },
        enumerable: false,
        configurable: true
    });
    PartnerControl.prototype.onPropertyChanged = function () {
        this.partner.name = "";
        this.partner.nameId = null;
        this.descriptionKey = Date();
    };
    Object.defineProperty(PartnerControl.prototype, "hasTargets", {
        get: function () {
            var _a;
            return ((_a = this.targets) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "partnerTypeOptions", {
        get: function () {
            return optionsFor(Option, "PartnerTypeOptions");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "cooperationTypeOptions", {
        get: function () {
            var _this = this;
            var $t = function (key) { return _this.$t(key); };
            return optionsFor(Option, "CooperationTypeOptions", false, $t);
        },
        enumerable: false,
        configurable: true
    });
    PartnerControl.prototype.getOptions = function (type) {
        var _this = this;
        var $t = function (key) { return _this.$t(key); };
        switch (type) {
            case PartnerType.Municipality:
                return this.municipalities;
            case PartnerType.Congregation:
                return this.congregations;
            case PartnerType.Region:
                return this.regions;
            case PartnerType.HealthCareDistrict:
                return optionsFor(Option, "HealthCareDistrictOptions", false, $t);
            default:
                break;
        }
    };
    PartnerControl.prototype.getTitle = function (type) {
        switch (type) {
            case PartnerType.Municipality:
                return "ContinuousReportSummary.Collaboration.Partners.Municipality";
            case PartnerType.Organisation:
                return "ContinuousReportSummary.Collaboration.Partners.STEAOrganisationName";
            case PartnerType.Congregation:
                return "ContinuousReportSummary.Collaboration.Partners.CongregationName";
            case PartnerType.Region:
                return "ContinuousReportSummary.Collaboration.Partners.Region";
            case PartnerType.HealthCareDistrict:
                return "ContinuousReportSummary.Collaboration.Partners.HealthCareDistrict";
            case PartnerType.Other:
                return "ContinuousReportSummary.Collaboration.Partners.OtherDescription";
            default:
                break;
        }
    };
    var _a;
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof ContinuousReportSummaryPartner !== "undefined" && ContinuousReportSummaryPartner) === "function" ? _a : Object)
    ], PartnerControl.prototype, "partner", void 0);
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], PartnerControl.prototype, "targets", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], PartnerControl.prototype, "index", void 0);
    __decorate([
        Watch("partner.type"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PartnerControl.prototype, "onPropertyChanged", null);
    PartnerControl = __decorate([
        Component({
            name: "PartnerControl",
            components: {
                OrganisationSearchAndSelect: OrganisationSearchAndSelect,
                SingleSelectAccessible: SingleSelectAccessible,
                MultiselectRowAccessible: MultiselectRowAccessible,
                TextAreaRow: TextAreaRow,
                CheckBoxDialogRow: CheckBoxDialogRow,
            }
        })
    ], PartnerControl);
    return PartnerControl;
}(Mixins(MasterDataConsumer, Savable)));
export default PartnerControl;
